import { WalletType as n } from "../../temp-lib/constants/web3.js";
var o = /* @__PURE__ */ ((e) => (e.Connect = "connect", e.SignMessage = "sign-message", e.SignTransaction = "sign-transaction", e.None = "none", e))(o || {});
const t = {
  [n.Metamask]: {
    nameKey: "wallet.name.metamask",
    download: {
      chrome: "https://chrome.google.com/webstore/detail/metamask/nkbihfbeogaeaoehlefnkodbefgpgknn",
      firefox: "https://addons.mozilla.org/en-US/firefox/addon/ether-metamask/"
    }
  },
  [n.Ronin]: {
    nameKey: "wallet.name.ronin",
    download: {
      chrome: "https://chrome.google.com/webstore/detail/ronin-wallet/fnjhmkhhmkbjkkabndcnnogagogbneec",
      firefox: "https://addons.mozilla.org/en-US/firefox/addon/ronin-wallet/"
    }
  }
};
export {
  o as MobileWalletSnackBarMode,
  t as WalletInfo
};
//# sourceMappingURL=index.js.map
